import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaCalculoCalcularResultadosNoremuneradoComponent {
  constructor () {
    this.data = {}
  }
}

module.component('nominasNominaCalculoCalcularResultadosNoremunerado', {
  controller: NominasNominaCalculoCalcularResultadosNoremuneradoComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/calculo/calcular/resultados/noremunerado/component.js